/** packages/shared-components/src/components/Keyboard/utils.tsx */

import { KeyLightingConfig, KeyConfig } from "./types";

/** 辅助函数：RGB 转 HEX */
export const rgbToHex = (r: number, g: number, b: number): string => {
  return `#${[r, g, b]
    .map((x) => Math.max(0, Math.min(255, x)).toString(16).padStart(2, "0"))
    .join("")}`;
};

/** 辅助函数：应用亮度到 RGB */
export const applyBrightness = (
  rgb: KeyLightingConfig,
  brightness: number
): string => {
  const factor = brightness / 100;
  return rgbToHex(
    Math.round(rgb.R * factor),
    Math.round(rgb.G * factor),
    Math.round(rgb.B * factor)
  );
};

/** 判断是否为间距占位符 */
export const isGap = (key: KeyConfig): boolean =>
  key.code === "__gap__" || (key.keyCode === 1 && key.multipleWidth === 0);
